// show the element's title attribute text in a box.
function titleClickHandler(evt: Event) {
  const titleElem = evt.target as Element;
  const title = titleElem.getAttribute('title') ?? '';
  const inputElem = titleElem?.nextSibling?.firstChild as Element;

  const invalidity_reason = (
    Object.hasOwn(inputElem, 'hasAttribute') && inputElem?.hasAttribute('fin-invalid')
  )
    ? (inputElem.getAttribute('fin-invalid') ?? '')
    : '';

  if (!title) {
    return;
  }

  const msg: string = '<b>' + title + '</b>' + (
    invalidity_reason
      ? (
        '<br/><br/>'
        + '<span class="fin-invalidity-reason">'
        + invalidity_reason
        + '</span>'
      )
      : ''
  ) + '<br/><br/>'
  + 'Click anywhere to close.';

  const box = document.createElement('div');
  box.setAttribute('id', 'fin-help-box');
  box.innerHTML = msg;
  document.body.append(box);

  box.addEventListener(
    'click',
    _evt => {
      box.remove();
    },
  );

  globalThis.addEventListener(
    'keyup',
    _evt => {
      box?.remove();
    },
    {once: true},
  );
}

// touchscreen users (mobile) don't get hover text...
export function placeClickHandlersOnElementsWithTitleAttributes(doc: Document) {
  const targets: Element[] = [...doc.querySelectorAll('*[title]')]
    .filter((elem: Element) => elem.localName !== 'input');

  for (const t of targets) {
    t.addEventListener('click', titleClickHandler);
    if (t.nodeName.toLowerCase() !== 'hr') {
      t.textContent += ' ⓘ';
    }
  }
}
